import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["benchmarks", "className", "currency", "currencyDisplay", "dataFormat", "heading", "id", "isCompact", "layout", "locale", "maximumFractionDigits", "minimumFractionDigits", "maxValue", "minValue", "mode", "size", "value"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, Fragment, useCallback, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import Caption from '../Caption';
import FormatCurrency from '../FormatCurrency';
import FormatNumber from '../FormatNumber';
import ShiftBy from '../ShiftBy';
import Tooltip from '../Tooltip';
import { Styled } from './GaugeBar.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var GaugeBar = forwardRef(function (_ref, ref) {
  var _cx, _heading$showPercenta, _heading$showValue, _currentRange$status;

  var benchmarks = _ref.benchmarks,
      customClassName = _ref.className,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'GBP' : _ref$currency,
      _ref$currencyDisplay = _ref.currencyDisplay,
      currencyFormat = _ref$currencyDisplay === void 0 ? 'short' : _ref$currencyDisplay,
      _ref$dataFormat = _ref.dataFormat,
      dataFormat = _ref$dataFormat === void 0 ? 'number' : _ref$dataFormat,
      heading = _ref.heading,
      id = _ref.id,
      _ref$isCompact = _ref.isCompact,
      isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'stacked' : _ref$layout,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-GB' : _ref$locale,
      _ref$maximumFractionD = _ref.maximumFractionDigits,
      maximumFractionDigits = _ref$maximumFractionD === void 0 ? 2 : _ref$maximumFractionD,
      _ref$minimumFractionD = _ref.minimumFractionDigits,
      minimumFractionDigits = _ref$minimumFractionD === void 0 ? 0 : _ref$minimumFractionD,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? 100 : _ref$maxValue,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-gaugebar"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var currencyDisplay = currencyFormat === 'symbol' || currencyFormat === 'code' || currencyFormat === 'name' ? 'explicit' : currencyFormat === 'narrowSymbol' ? 'short' : currencyFormat;
  var formatCurrencyDefaults = {
    currency: currency,
    format: currencyDisplay,
    isCompact: isCompact,
    locale: locale,
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits
  };
  var formatNumberDefaults = {
    isCompact: isCompact,
    locale: locale,
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits
  };
  var isInline = layout === 'inline',
      isStacked = layout === 'stacked';
  var headingShowPercentage = dataFormat === 'percentage' ? false : (_heading$showPercenta = heading === null || heading === void 0 ? void 0 : heading.showPercentage) !== null && _heading$showPercenta !== void 0 ? _heading$showPercenta : true;
  var headingShowValue = (_heading$showValue = heading === null || heading === void 0 ? void 0 : heading.showValue) !== null && _heading$showValue !== void 0 ? _heading$showValue : true;
  var hasHeading = isStacked && size === 'large' && ((heading === null || heading === void 0 ? void 0 : heading.title) || headingShowPercentage || headingShowValue);
  var gaugeRange = maxValue - minValue;
  var curentPercentage = value / gaugeRange * 100;

  var valueToPercent = function valueToPercent(val) {
    return val / gaugeRange * 100;
  };

  var getCurrentRange = useCallback(function () {
    var evaluate = function evaluate(value, benchmark) {
      var _benchmark$isPercenta;

      var isPercentage = (_benchmark$isPercenta = benchmark === null || benchmark === void 0 ? void 0 : benchmark.isPercentage) !== null && _benchmark$isPercenta !== void 0 ? _benchmark$isPercenta : false;
      var startValue = isPercentage ? benchmark.range.start : benchmark.range.start / gaugeRange * 100;
      var endValue = isPercentage ? benchmark.range.end : benchmark.range.end / gaugeRange * 100;

      if ((value - startValue) * (value - endValue) <= 0) {
        var _benchmark$range$desc, _benchmark$range, _benchmark$range$stat, _benchmark$range2;

        var description = (_benchmark$range$desc = (_benchmark$range = benchmark.range) === null || _benchmark$range === void 0 ? void 0 : _benchmark$range.description) !== null && _benchmark$range$desc !== void 0 ? _benchmark$range$desc : false,
            status = (_benchmark$range$stat = (_benchmark$range2 = benchmark.range) === null || _benchmark$range2 === void 0 ? void 0 : _benchmark$range2.status) !== null && _benchmark$range$stat !== void 0 ? _benchmark$range$stat : false;
        return _objectSpread(_objectSpread({}, description && {
          description: description
        }), status && {
          status: status
        });
      } else {
        return false;
      }
    };

    var ranges = [];

    if (benchmarks) {
      var _iterator = _createForOfIteratorHelper(benchmarks),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var benchmark = _step.value;

          if (benchmark.range) {
            ranges.push(evaluate(curentPercentage, benchmark));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return ranges.find(function (range) {
      return range !== false;
    });
  }, [benchmarks, curentPercentage, gaugeRange]);

  var _useState = useState(getCurrentRange()),
      _useState2 = _slicedToArray(_useState, 2),
      currentRange = _useState2[0],
      setCurrentRange = _useState2[1];

  useEffect(function () {
    setCurrentRange(getCurrentRange());
  }, [getCurrentRange]);

  function currentValueTooltip() {
    return _jsxs(_Fragment, {
      children: [dataFormat === 'currency' ? _jsx(FormatCurrency, _objectSpread(_objectSpread({}, formatCurrencyDefaults), {}, {
        value: value
      })) : _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
        format: dataFormat === 'percentage' ? 'percent' : 'decimal',
        value: dataFormat === 'percentage' ? value / 100 : value
      })), dataFormat !== 'percentage' && _jsxs(_Fragment, {
        children: [' (', _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
          format: "percent",
          maximumFractionDigits: 0,
          value: curentPercentage / 100
        })), ')']
      })]
    });
  }

  function benchmarkValueTooltip(benchmark, isPercentage) {
    return _jsxs(Caption, {
      children: [dataFormat === 'currency' && _jsx(FormatCurrency, _objectSpread(_objectSpread({}, formatCurrencyDefaults), {}, {
        value: isPercentage ? benchmark.value / 100 * gaugeRange : benchmark.value
      })), dataFormat === 'number' && _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
        format: "decimal",
        value: isPercentage ? benchmark.value / 100 * gaugeRange : benchmark.value
      })), dataFormat === 'percentage' && _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
        format: "percent",
        value: isPercentage ? benchmark.value / 100 * gaugeRange / 100 : benchmark.value / 100
      })), (dataFormat !== 'percentage' || dataFormat === 'percentage' && maxValue !== 100) && _jsxs(_Fragment, {
        children: [' (', _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
          format: "percent",
          value: isPercentage ? benchmark.value / 100 : benchmark.value / gaugeRange
        })), ')']
      })]
    });
  }

  function benchmarkRangeTooltip(benchmark, isPercentage) {
    var _benchmark$range3;

    return _jsxs(_Fragment, {
      children: [dataFormat === 'currency' && _jsxs(Caption, {
        children: [_jsx(FormatCurrency, _objectSpread(_objectSpread({}, formatCurrencyDefaults), {}, {
          format: "short",
          value: isPercentage ? benchmark.range.start / 100 * gaugeRange : benchmark.range.start
        })), _jsx(_Fragment, {
          children: " \u2013 "
        }), _jsx(FormatCurrency, _objectSpread(_objectSpread({}, formatCurrencyDefaults), {}, {
          value: isPercentage ? benchmark.range.end / 100 * gaugeRange : benchmark.range.end
        }))]
      }), dataFormat === 'number' && _jsxs(Caption, {
        children: [_jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
          format: "decimal",
          value: isPercentage ? benchmark.range.start / 100 * gaugeRange : benchmark.range.start
        })), _jsx(_Fragment, {
          children: " \u2013 "
        }), _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
          format: "decimal",
          value: isPercentage ? benchmark.range.end / 100 * gaugeRange : benchmark.range.end
        }))]
      }), dataFormat === 'percentage' && _jsxs(Caption, {
        children: [_jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
          format: "percent",
          value: isPercentage ? benchmark.range.start / 100 * gaugeRange / 100 : benchmark.range.start / 100
        })), _jsx(_Fragment, {
          children: " \u2013 "
        }), _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
          format: "percent",
          value: isPercentage ? benchmark.range.end / 100 * gaugeRange / 100 : benchmark.range.end / 100
        }))]
      }), (benchmark === null || benchmark === void 0 ? void 0 : (_benchmark$range3 = benchmark.range) === null || _benchmark$range3 === void 0 ? void 0 : _benchmark$range3.description) && _jsx(ShiftBy, {
        y: 4,
        children: _jsx(Caption, {
          isSecondary: true,
          isItalic: true,
          children: benchmark.range.description
        })
      })]
    });
  }

  function renderBenchmarks() {
    return benchmarks.map(function (benchmark, index) {
      var _benchmark$isPercenta2, _benchmark$value, _benchmark$range4, _benchmark$range$star, _benchmark$range5, _benchmark$range$endT, _benchmark$range6;

      var startPos, endPos;
      var isPercentage = (_benchmark$isPercenta2 = benchmark === null || benchmark === void 0 ? void 0 : benchmark.isPercentage) !== null && _benchmark$isPercenta2 !== void 0 ? _benchmark$isPercenta2 : false;
      var isValue = (_benchmark$value = benchmark === null || benchmark === void 0 ? void 0 : benchmark.value) !== null && _benchmark$value !== void 0 ? _benchmark$value : false;
      var isRange = (_benchmark$range4 = benchmark === null || benchmark === void 0 ? void 0 : benchmark.range) !== null && _benchmark$range4 !== void 0 ? _benchmark$range4 : false;
      var hasStartTick = (_benchmark$range$star = benchmark === null || benchmark === void 0 ? void 0 : (_benchmark$range5 = benchmark.range) === null || _benchmark$range5 === void 0 ? void 0 : _benchmark$range5.startTick) !== null && _benchmark$range$star !== void 0 ? _benchmark$range$star : true;
      var hasEndTick = (_benchmark$range$endT = benchmark === null || benchmark === void 0 ? void 0 : (_benchmark$range6 = benchmark.range) === null || _benchmark$range6 === void 0 ? void 0 : _benchmark$range6.endTick) !== null && _benchmark$range$endT !== void 0 ? _benchmark$range$endT : true;

      if (isRange) {
        startPos = isPercentage ? benchmark.range.start : valueToPercent(benchmark.range.start);
        endPos = isPercentage ? benchmark.range.end : valueToPercent(benchmark.range.end);
      } else if (isValue) {
        endPos = isPercentage ? benchmark.value : valueToPercent(benchmark.value);
      }

      return _jsx(Fragment, {
        children: hasEndTick && _jsxs(Styled.TickContainer, {
          style: _objectSpread({}, isRange ? {
            left: "".concat(startPos, "%"),
            width: "calc(".concat(endPos, "% - ").concat(startPos, "%)")
          } : {
            left: "calc(".concat(endPos, "% - 5px)")
          }),
          children: [isRange && hasStartTick && startPos > 0 && _jsx(Styled.Tick, {
            style: {
              left: 0
            }
          }), endPos < 100 && _jsx(Styled.Tick, {
            style: _objectSpread({}, isRange && {
              left: '100%'
            })
          }), _jsx(Tooltip, {
            content: benchmark !== null && benchmark !== void 0 && benchmark.tooltip ? benchmark.tooltip : isRange ? benchmarkRangeTooltip(benchmark, isPercentage) : benchmarkValueTooltip(benchmark, isPercentage),
            position: "top",
            size: "medium",
            children: _jsx(Styled.TickTooltipTarget, {
              isRange: isRange
            })
          })]
        })
      }, index);
    });
  }

  function renderGoals() {
    return benchmarks.map(function (benchmark, index) {
      var _benchmark$isPercenta3, _benchmark$value2, _benchmark$range7, _benchmark$isGoal;

      var goalTarget;
      var isPercentage = (_benchmark$isPercenta3 = benchmark === null || benchmark === void 0 ? void 0 : benchmark.isPercentage) !== null && _benchmark$isPercenta3 !== void 0 ? _benchmark$isPercenta3 : false;
      var isValue = (_benchmark$value2 = benchmark === null || benchmark === void 0 ? void 0 : benchmark.value) !== null && _benchmark$value2 !== void 0 ? _benchmark$value2 : false;
      var isRange = (_benchmark$range7 = benchmark === null || benchmark === void 0 ? void 0 : benchmark.range) !== null && _benchmark$range7 !== void 0 ? _benchmark$range7 : false;
      var isGoal = (_benchmark$isGoal = benchmark === null || benchmark === void 0 ? void 0 : benchmark.isGoal) !== null && _benchmark$isGoal !== void 0 ? _benchmark$isGoal : false;

      if (isRange) {
        goalTarget = isPercentage ? benchmark.range.end : valueToPercent(benchmark.range.end);
      } else if (isValue) {
        goalTarget = isPercentage ? benchmark.value : valueToPercent(benchmark.value);
      }

      return _jsx(Fragment, {
        children: isGoal && _jsx(Styled.Goal, {
          style: {
            width: "".concat(goalTarget, "%"),
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
            borderTopRightRadius: "".concat(goalTarget === 100 ? '8px' : 0),
            borderBottomRightRadius: "".concat(goalTarget === 100 ? '8px' : 0)
          }
        })
      }, index);
    });
  }

  return _jsx(ThemeProvider, {
    theme: {
      layout: layout,
      mode: mode,
      size: size
    },
    children: _jsxs(Styled.Container, _objectSpread(_objectSpread({
      ref: ref,
      className: className
    }, rest), {}, {
      children: [hasHeading && _jsxs(Styled.Heading, {
        children: [(heading === null || heading === void 0 ? void 0 : heading.title) && _jsx(Styled.Title, {
          children: heading.title
        }), _jsxs(Styled.Actual, {
          children: [headingShowValue && _jsx(Styled.Value, {
            children: dataFormat === 'currency' ? _jsx(FormatCurrency, _objectSpread(_objectSpread({}, formatCurrencyDefaults), {}, {
              value: value
            })) : _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
              format: dataFormat === 'percentage' ? 'percent' : 'decimal',
              value: dataFormat === 'percentage' ? value / 100 : value
            }))
          }), headingShowPercentage && _jsxs(Styled.Percentage, {
            children: ['(', _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
              format: "percent",
              maximumFractionDigits: 0,
              value: curentPercentage / 100
            })), ')']
          })]
        })]
      }), _jsxs(Styled.Chart, {
        children: [_jsx(Styled.Surface, {
          children: _jsxs(Styled.Inner, {
            children: [_jsx(Styled.Track, {}), benchmarks && renderGoals(), _jsx(Styled.Bar, {
              isComplete: curentPercentage >= 100,
              status: (_currentRange$status = currentRange === null || currentRange === void 0 ? void 0 : currentRange.status) !== null && _currentRange$status !== void 0 ? _currentRange$status : null,
              style: {
                width: "".concat(curentPercentage >= 100 ? 100 : curentPercentage, "%")
              }
            }), benchmarks && renderBenchmarks(), curentPercentage > 0 && _jsxs(Styled.TickContainer, {
              isComplete: curentPercentage >= 100,
              style: {
                left: "calc(".concat(curentPercentage, "% - 5px)")
              },
              children: [_jsx(Styled.Pin, {}), _jsx(Tooltip, {
                content: currentValueTooltip(),
                position: "top",
                size: "medium",
                children: _jsx(Styled.TickTooltipTarget, {})
              })]
            })]
          })
        }), _jsxs(Styled.MinMaxLabels, {
          children: [isStacked && _jsxs(_Fragment, {
            children: [_jsx(Styled.Label, {
              children: dataFormat === 'currency' ? _jsx(FormatCurrency, _objectSpread(_objectSpread({}, formatCurrencyDefaults), {}, {
                format: 'short',
                value: minValue
              })) : _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
                format: dataFormat === 'percentage' ? 'percent' : 'decimal',
                value: dataFormat === 'percentage' ? minValue / 100 : minValue
              }))
            }), _jsx(Styled.Label, {
              children: dataFormat === 'currency' ? _jsx(FormatCurrency, _objectSpread(_objectSpread({}, formatCurrencyDefaults), {}, {
                format: size === 'large' ? 'short' : currencyDisplay,
                value: maxValue
              })) : _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
                format: dataFormat === 'percentage' ? 'percent' : 'decimal',
                value: dataFormat === 'percentage' ? maxValue / 100 : maxValue
              }))
            })]
          }), isInline && _jsx(Styled.Label, {
            children: _jsx(FormatNumber, _objectSpread(_objectSpread({}, formatNumberDefaults), {}, {
              format: "percent",
              maximumFractionDigits: dataFormat === 'percentage' ? maximumFractionDigits : 0,
              value: dataFormat === 'percentage' ? value / 100 : curentPercentage / 100
            }))
          })]
        })]
      }), (currentRange === null || currentRange === void 0 ? void 0 : currentRange.description) && _jsx(Styled.RangeDescription, {
        children: currentRange.description
      })]
    }))
  });
});
GaugeBar.displayName = 'GaugeBar';
export default GaugeBar;